import { PieceSlider, PieceDescription, PieceUnorderedList} from '@store/index';
const PUBLIC_URL = process.env.REACT_APP_URL;

const holidayAccommodation = {
    name: 'Holiday Accommodation',
    slug: 'holiday-accommodation',
    description: 'Application for renting hotel, furnished apartment, house or professionally managed resort-condominium complex around the world.',
    cover: {
        url: `${PUBLIC_URL}/portfolio/holiday-accommodation/cover.jpg`,
        license: {
            link: 'http://www.freepik.com',
            text: 'Designed by macrovector / Freepik'
        }
    },
    prominentColor: 'rgb(207,227,195)',
    pieces: [
        {
            type: 'slider',
            images: [
                {
                    url: `${PUBLIC_URL}/portfolio/holiday-accommodation/paradise.jpg`,
                    license: {
                        link: 'http://www.freepik.com',
                        text: 'Designed by lifeforstock / Freepik'
                    }
                },{
                    url: `${PUBLIC_URL}/portfolio/holiday-accommodation/hotel.jpg`,
                    license: {
                        link: 'http://www.freepik.com',
                        text: 'Designed by vectorpocket / Freepik'
                    }
                },{
                    url: `${PUBLIC_URL}/portfolio/holiday-accommodation/reception.jpg`,
                    license: {
                        link: 'http://www.freepik.com',
                        text: 'Designed by Freepik'
                    }
                },{
                    url: `${PUBLIC_URL}/portfolio/holiday-accommodation/tropical.jpg`,
                    license: {
                        link: 'http://www.freepik.com',
                        text: 'Designed by lifeforstock / Freepik'
                    }
                },{
                    url: `${PUBLIC_URL}/portfolio/holiday-accommodation/beach.jpg`,
                    license: {
                        link: 'http://www.freepik.com',
                        text: 'Designed by Freepik'
                    }
                },{
                    url: `${PUBLIC_URL}/portfolio/holiday-accommodation/cover.jpg`,
                    license: {
                        link: 'http://www.freepik.com',
                        text: 'Designed by macrovector / Freepik'
                    }
                }
            ]
        } as PieceSlider,
        {
            type: 'description',
            title: 'Highlights',
            description: 'Service oriented architecture',
        } as PieceDescription,
        {
            type: 'description',
            title: 'Role',
            description: 'Back-End developer',
        } as PieceDescription,
        {
            type: 'unordered list',
            title: 'Main Technologies',
            items: ['JAVA', 'Spring', 'MS SQL', 'MyBatis'],
        } as PieceUnorderedList,
    ],
}

export default holidayAccommodation;


// WEBPACK FOOTER //
// ./src/store/portfolio/holiday-accommodation.tsx